import { default as  timerworker_script } from './workerscript'

class TWorker {

    constructor(worker_script) {

        this.worker = new Worker(worker_script)

    }

    wait(ms) {
        return new Promise((res, rej) => {
            const channel = new MessageChannel();

            channel.port1.onmessage = (result) => {
                let data = result.data
                channel.port1.close();
                if (data.error) {
                    rej(data.error);
                } else {
                    res(data.result);
                }
            }
            this.worker.postMessage({ method: "wait", methodArgs: [ms] }, [channel.port2]);
        });
    }
}
const TimerWorker = new TWorker(timerworker_script)

export {TimerWorker}